module.exports = __webpack_public_path__ + "static/img/medium.25db7ddc.svg";